module.exports = __webpack_public_path__ + "img/sjUnion.3da44093.png";